<template>
  <div class="col-md-8 pd-5">
    <div class="card p-1 mb-0">
      <div class="d-flex justify-content-between align-items-center">
        <span>{{ statisticsItem[itemKey].data.name }}</span>
      </div>

      <div class="btn-group d-flex flex-wrap gap-1 p-1">
        <button
          v-for="type in tabs"
          :key="type"
          class="btn btn-sm flex-grow-1"
          :class="activeTab === type ? 'btn-primary' : 'btn-outline-primary'"
          @click="changeType(type)"
        >
          {{ type.toUpperCase() }}
        </button>
      </div>

      <HosSummaryTable
        v-if="statisticsItem[itemKey].data[activeTab]"
        :summary="statisticsItem[itemKey].data[activeTab]"
      />
      <div v-else class="p-2 text-center text-muted">
        Please refresh the dashboard to load summary data.
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import HosSummaryTable from "@/components/molecule/company/dashboard/dynamic-dashboard/hospital-table/HosSummaryTable";

const emit = defineEmits(['onTypeChange']);

defineProps({
  statisticsItem: Object,
  itemKey: String,
  page: Object,
});

const changeType = (type) => {
  activeTab.value = type;
  emit('onTypeChange', props.statisticsItem[props.itemKey], type);
}

const tabs = ['billing', 'investigation', 'incentive', 'accounts'];

const activeTab = ref("billing");
</script>
